'use client'

import { useLayoutEffect } from 'react'
import { useError } from '@/components/ErrorContext'
import Link from 'next/link'
import { ArrowLeft } from '@phosphor-icons/react'

export default function NotFound() {
  const { setError } = useError()

  // useLayoutEffect runs before useEffect, ensuring error is set before PageMeasurement pushes
  useLayoutEffect(() => {
    setError({ type: '404', message: 'Page not found' })
    return () => setError(null)
  }, [setError])

  return (
    <main className="portfolio-page flex min-h-[calc(100dvh-76px)] flex-col items-center justify-center px-4 text-center">
      <p className="font-mono text-sm text-[var(--portfolio-accent-text)]">404</p>
      <h1 className="mt-5 text-5xl font-normal tracking-[-0.04em] text-[var(--portfolio-ink)] sm:text-6xl">Page not found.</h1>
      <p className="mt-5 max-w-md text-lg leading-8 text-[var(--portfolio-muted)]">The address may have changed, or the page may no longer exist.</p>
      <Link
        href="/"
        className="mt-8 inline-flex min-h-12 items-center gap-3 rounded-[8px] bg-[var(--portfolio-mint)] px-6 py-3 font-semibold text-[#102b32] transition hover:-translate-y-px hover:bg-[#19f0ad]"
      >
        <ArrowLeft size={18} aria-hidden="true" /> Back home
      </Link>
    </main>
  )
}
